module.exports = __webpack_public_path__ + "static/gallery02-22708ca7367ce366cea930ac39db3bb1.jpg";